<template>
	<section class="other_page_banner platformban banner_nxt_sec_touch">
		<div class="container">
			<div class="row">
				<div class="col-sm-7 order-2 order-md-1">
					<div class="ban_lt">
						<h2>
							{{ $t('new_ui.business_platform_page.section_banner.title.one') }}
							<br />{{
								$t('new_ui.business_platform_page.section_banner.title.two')
							}}
						</h2>
						<p>
							{{
								$t(
									'new_ui.business_platform_page.section_banner.paragraph.one',
								)
							}}<br />
							{{
								$t('new_ui.business_platform_page.section_banner.paragraph.two')
							}}
							<br />{{
								$t(
									'new_ui.business_platform_page.section_banner.paragraph.three',
								)
							}}
						</p>

						<div
							class="ban_lt_btn d-flex justify-content-start align-items-center p-top"
						></div>
					</div>
				</div>
				<div class="col-sm-5 order-1 order-md-2">
					<div class="ban_rt">
						<img :src="img.image1" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="seller_access deposit_mid">
		<div class="container">
			<div class="row">
				<div class="col-sm-6">
					<div class="seller_access_lt">
						<img class="w-100" :src="img.image2" alt="" />
					</div>
				</div>
				<div class="col-sm-6">
					<div class="seller_access_rt">
						<span>{{
							$t('new_ui.business_platform_page.seller_access.label')
						}}</span>
						<div class="seller_access_txt">
							<h4>
								{{ $t('new_ui.business_platform_page.seller_access.title.one')
								}}<br />
								<span>{{
									$t('new_ui.business_platform_page.seller_access.title.two')
								}}</span>
								{{
									$t('new_ui.business_platform_page.seller_access.title.three')
								}}<br />
								{{
									$t('new_ui.business_platform_page.seller_access.title.four')
								}}
							</h4>
							<p>
								{{
									$t('new_ui.business_platform_page.seller_access.paragraph')
								}}
							</p>
							<div class="starting_to_btn">
								<a href="/auth/register">{{
									$t(
										'new_ui.business_platform_page.seller_access.cta_buttons.one',
									)
								}}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="question_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-4 question_mob">
					<div class="question_lt">
						<img :src="img.image5" alt="" />
					</div>
				</div>
				<div class="col-sm-8">
					<div class="question_rt">
						<div class="payment_world_right">
							<span>{{
								$t('new_ui.business_platform_page.question_sec.label')
							}}</span>
							<div class="payment_world_txt">
								<h4>
									{{
										$t('new_ui.business_platform_page.question_sec.title.one')
									}}
									<span>{{
										$t('new_ui.business_platform_page.question_sec.title.two')
									}}</span>
									{{
										$t('new_ui.business_platform_page.question_sec.title.three')
									}}
								</h4>
								<p>
									{{
										$t(
											'new_ui.business_platform_page.question_sec.paragraph.one',
										)
									}}<br />
									{{
										$t(
											'new_ui.business_platform_page.question_sec.paragraph.two',
										)
									}}<br />
									{{
										$t(
											'new_ui.business_platform_page.question_sec.paragraph.three',
										)
									}}
								</p>
								<div class="starting_to_btn pay_world">
									<a href="/auth/register">{{
										$t(
											'new_ui.business_platform_page.question_sec.cta_buttons.one',
										)
									}}</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-sm-4 question_desk">
					<div class="question_lt">
						<img :src="img.image3" alt="" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="seller_access">
		<div class="container">
			<div class="row">
				<div class="col-sm-6">
					<div class="seller_access_lt">
						<img :src="img.image4" alt="" />
					</div>
				</div>
				<div class="col-sm-6">
					<div class="seller_access_rt">
						<span>{{
							$t('new_ui.business_platform_page.seller_access_rt.label')
						}}</span>
						<div class="seller_access_txt">
							<h4>
								{{
									$t('new_ui.business_platform_page.seller_access_rt.title.one')
								}}
								<span
									>{{
										$t(
											'new_ui.business_platform_page.seller_access_rt.title.two',
										)
									}}<br />
									{{
										$t(
											'new_ui.business_platform_page.seller_access_rt.title.three',
										)
									}}</span
								>
								{{
									$t(
										'new_ui.business_platform_page.seller_access_rt.title.four',
									)
								}}
							</h4>
							<p>
								{{
									$t('new_ui.business_platform_page.seller_access_rt.paragraph')
								}}
							</p>
							<div class="starting_to_btn">
								<a href="/auth/register">{{
									$t(
										'new_ui.business_platform_page.seller_access_rt.cta_buttons.one',
									)
								}}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t('new_ui.business_platform_page.section_newsletter.label')
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t(
										'new_ui.business_platform_page.section_newsletter.title.one',
									)
								}}</span>
								{{
									$t(
										'new_ui.business_platform_page.section_newsletter.title.two',
									)
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.business_platform_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.business_platform_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.business_platform_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.business_platform_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import platformban from '@/assets/images/sub/platform_ban.png';
import p1 from '@/assets/images/sub/p1.png';
import p2 from '@/assets/images/sub/p2.png';
import p3 from '@/assets/images/sub/p3.png';
import platdia from '@/assets/images/sub/plat_dia.png';

export default {
	data: () => {
		return {
			img: {
				image1: platformban,
				image2: p1,
				image3: p2,
				image4: p3,
				image5: platdia,
			},
		};
	},
};
</script>
